<template>
    <!-- section  -->				
    <section class="scroll-con-sec" id="sec4">
        <div class="container">
            <div class="section-title fl-wrap">
                <h2>Our Awesome <strong>Team</strong></h2>
                <p>{{ sectionSubtitle }}</p>
                <div class="sec-title_dec"></div>
            </div>
            <div class="row">
                <!-- team-box   --> 
                <div class="col-md-6" v-for="(member, index) in teamMembers" :key="member.id">
                    <div class="team-box">
                        <div class="team-photo">
                            <div class="overlay"></div>
                            <img :src="member.image" :alt="member.name" class="respimg">
                            <ul class="team-social" v-if="member.social && member.social.length">
                                <li v-for="(link, idx) in member.social" :key="idx">
                                    <a :href="link.url" target="_blank">{{ link.label }}</a>
                                </li>
                            </ul>
                            <div class="team-info-num">{{ String(index + 1).padStart(2, '0') }}.</div>
                            <router-link 
                                v-if="member.slug"
                                :to="'/pages/' + member.slug" 
                                class="team-link"
                            >View Details</router-link>
                        </div>
                        <div class="team-info">
                            <h3>
                                <router-link 
                                    v-if="member.slug"
                                    :to="'/pages/' + member.slug"
                                >{{ member.name }}</router-link>
                                <span v-else>{{ member.name }}</span>
                            </h3>
                            <h4>{{ member.position }}</h4>
                            <p>{{ member.bio }}</p>
                        </div>
                    </div>
                </div>
                <!-- team-box end --> 
            </div>
        </div>
        <div class="section-number"><span>0</span>4<strong>.</strong></div>
    </section>
    <!-- section end-->
</template>

<script>
export default {
    name: 'TeamSection',
    data() {
        return {
            sectionSubtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas in pulvinar neque.',
            teamMembers: []
        }
    },
    async mounted() {
        await this.loadTeamMembers()
    },
    methods: {
        async loadTeamMembers() {
            try {
                const response = await this.$api.get('public/team')
                if (response.data && response.data.status === 'success') {
                    this.teamMembers = (response.data.data || []).slice(0, 4).map(member => ({
                        id: member.id,
                        name: member.name,
                        position: member.position || member.title,
                        bio: member.bio || member.excerpt,
                        image: member.image || member.photo,
                        slug: member.slug,
                        social: this.parseSocial(member.social)
                    }))
                }
            } catch (error) {
                console.error('Failed to load team members:', error)
                // Use default team members
                this.teamMembers = this.getDefaultTeam()
            }
            
            // If no team members loaded, use defaults
            if (this.teamMembers.length === 0) {
                this.teamMembers = this.getDefaultTeam()
            }
        },
        
        parseSocial(social) {
            if (Array.isArray(social)) {
                return social.slice(0, 4).map(s => ({
                    url: s.url || s.link,
                    label: this.getSocialLabel(s.platform || s.name)
                }))
            }
            return [
                { url: '#', label: 'Fb' },
                { url: '#', label: 'In' },
                { url: '#', label: 'Tw' },
                { url: '#', label: 'Vk' }
            ]
        },
        
        getSocialLabel(platform) {
            const labelMap = {
                'facebook': 'Fb',
                'twitter': 'Tw',
                'instagram': 'In',
                'linkedin': 'In',
                'vkontakte': 'Vk',
                'behance': 'Be'
            }
            return labelMap[platform.toLowerCase()] || platform.substring(0, 2).toUpperCase()
        },
        
        getDefaultTeam() {
            return [
                {
                    id: 1,
                    name: 'David Gray',
                    position: 'CEO / Architect',
                    bio: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
                    image: '/assets/img/team/1.jpg',
                    slug: 'david-gray',
                    social: [
                        { url: '#', label: 'Fb' },
                        { url: '#', label: 'In' },
                        { url: '#', label: 'Tw' },
                        { url: '#', label: 'Vk' }
                    ]
                },
                {
                    id: 2,
                    name: 'Alica Limishko',
                    position: 'Architect / Designer',
                    bio: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
                    image: '/assets/img/team/2.jpg',
                    slug: 'alica-limishko',
                    social: [
                        { url: '#', label: 'Fb' },
                        { url: '#', label: 'In' },
                        { url: '#', label: 'Tw' },
                        { url: '#', label: 'Vk' }
                    ]
                },
                {
                    id: 3,
                    name: 'Olivia Edminton',
                    position: 'Architect / Designer',
                    bio: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
                    image: '/assets/img/team/4.jpg',
                    slug: 'olivia-edminton',
                    social: [
                        { url: '#', label: 'Fb' },
                        { url: '#', label: 'In' },
                        { url: '#', label: 'Tw' },
                        { url: '#', label: 'Vk' }
                    ]
                },
                {
                    id: 4,
                    name: 'Kevin Brunt',
                    position: 'Architect / Designer',
                    bio: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
                    image: '/assets/img/team/3.jpg',
                    slug: 'kevin-brunt',
                    social: [
                        { url: '#', label: 'Fb' },
                        { url: '#', label: 'In' },
                        { url: '#', label: 'Tw' },
                        { url: '#', label: 'Vk' }
                    ]
                }
            ]
        }
    }
}
</script>

